<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Seleccionar ubicación'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div
    class="m-t-5 m-b-15"
    fxLayoutAlign="center center">

    <mat-form-field
      class="input-search-place mat-elevation-z6"
      floatLabel="never">
      <mat-label>Buscar dirección</mat-label>
      <input
        #searchPlace
        matInput
        placeholder="Buscar dirección"
        aria-label>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

  </div>

  <div
    fxLayout="column"
    fxLayoutAlign="center flex-start">
    <div *ngIf="address">
      <div>Tu ubicación actual es:</div>

      <div class="font-bold">{{address}}</div>

      <div class="m-t-5 m-b-5">
        Esta ubicación se utilizará para
      calcular las distancias al centro de estudios
      </div>
      <div class="m-t-15 m-b-5">
        Para cambiarla, ingresa una dirección o ubícala arrastrando el mapa
      </div>
    </div>

    <div *ngIf="!address">
      Busca tu ubicación o presiona el botón "Ubicarme"
    </div>

  </div>

  <div class="m-t-5 m-b-5">
    <google-map
      width="100%"
      height="450px"
      [options]="mapOptions"
      [center]="center"
      [zoom]="zoom">
      <map-marker
        [position]="marker.position"
        [label]="marker.label"
        [title]="marker.title"
        [options]="marker.options"
        (mapDragend)="handleDragEnd($event)"
        #mapMarker>
      </map-marker>
      <map-info-window [options]="infoWindowOptions">{{ infoWindowMessage }}</map-info-window>
    </google-map>
  </div>

  <div
    class="m-t-5 m-b-5"
    fxlayout="column">
    <div fxLayoutAlign="center center">
      <button
        mat-button
        type="button"
        class="text-naranja-sunedu m-r-15 m-l-15"
        (click)="handleTryGetGeoLocation()">
        Ubicarme
      </button>
    </div>

    <div
      class="m-t-5 m-b-5"
      fxLayoutAlign="center center">
      <button
        mat-raised-button
        [disabled]="!position"
        type="button"
        class="bg-naranja-sunedu m-r-15 m-l-15 rounded-full btn-aceptar"
        (click)="handleSubmitGeolocation()">
        Aceptar
      </button>
      <button
        mat-button
        type="button"
        class="text-naranja-sunedu  m-r-15 m-l-15"
        (click)="dialogRef.close()">
        Cancelar
      </button>
    </div>
  </div>

</lib-modal-container>
